"use client"; 

// Button before sign up wall 
import { Fragment, useRef } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { BoltIcon } from '@heroicons/react/20/solid'

import LandingForm from '../landing/landingForm'


export default function SignUpModal({ open=false, setOpen }) {
  // open, setOpen is controlled by parent component. 
  const cancelButtonRef = useRef(null)
   
  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="mt-6 fixed top-0 z-50 inset-0 overflow-y-auto" initialFocus={cancelButtonRef} onClose={setOpen}>
        <div className="flex items-start justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>
          

          {/* This element is to trick the browser into centering the modal contents. */}
          <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-2xl sm:w-full">
              
              <div className="bg-white px-4 py-6 ">
                {/* pt-5 pb-4 sm:p-6 sm:pb-4 */}
                
                <div className="mx-3 mt-3 sm:flex sm:items-start">
                  <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-crisp-100 sm:mx-0 sm:h-12 sm:w-12">
                    <BoltIcon className="h-8 w-8 text-crisp-600" aria-hidden="true" />
                  </div>
                  <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                    <Dialog.Title as="h3" className="text-lg leading-6 font-medium text-gray-900">
                      Welcome to Stackreaction
                    </Dialog.Title>

                    <div className="mt-0">

                      <p className="text-md text-crisp-700 font-semibold">
                        Sign up to get Early Access!
                      </p>
                    </div>
                  </div>
                </div>

                {/* FORM BLOCK */}
                <LandingForm 
                  formClass='px-3 my-3 sm:max-w-full sm:w-full sm:flex' 
                  buttonClass='bg-gradient-to-r from-purple-600 to-crisp-600  block w-full rounded-md shadow  px-8 md:px-10 py-3 md:py-4 text-base md:text-lg font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-crisp-300 focus:ring-offset-gray-900' 
                  onSuccess={() => { setOpen(false) }}
                />

              </div>
            
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>

  )
}
